import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OrganisationService } from 'src/app/providers/setups/organisation/organisation.service';
import { GeneralService } from 'src/app/providers/general/general.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { SysLogsComponent } from '../sys-logs/sys-logs.component';
declare let $: any;
@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  styleUrls: ['./finance.component.scss']
})
export class FinanceComponent implements OnInit {
  @Input() entitytypeid;
  // @Input() myFinance;
  @ViewChild(SysLogsComponent) sysLogs: SysLogsComponent;
  @Output() callSyslogFin = new EventEmitter<string>();
  // this.empLogsAdd();
  @Input() sourceid;
  @Input() config;
  @Input() logTable : any;
  myFinance: any = [];
  financeForm: FormGroup;
  subAdd = false;
  myAccountType: any;
  loading;
  response: any = [];
  result: any = [];
  myBank: any;
  dynamicHeader: any;
  public bankFile: any;
  FileBank: any;
  getRemBank: any;
  constructor(
    private formBuilder: FormBuilder,
    public httpOrg: OrganisationService,
    private genhttp: GeneralService,
    private notifyService: NotificationService) { }

  ngOnInit(): void {
    this.FinanceFormField();
    this.getEntityFinance();
    this.getReimbursementBank();
    this.getBanksList();
    this.getAccountsList();
    this.financeForm.patchValue({
      source_id: this.sourceid,
      entity_type_id: this.entitytypeid
    });
  }
  empLogsAdd(): void {
    this.callSyslogFin.emit('');
  }
  getBanksList(): void {
    this.genhttp.getBanks().subscribe( res => {
      this.result = res ;
      if (this.result.status === true) {
        this.myBank = this.result.data;
      } else {
        this.myBank = [{label: 'No Data Found' , value: '', disabled: true}];
      }
    });
  }
  getAccountsList(): void {
    this.genhttp.getAccounts().subscribe( res => {
      this.result = res ;
      if (this.result.status === true) {
        this.myAccountType = this.result.data;
      } else {
        this.myAccountType = [{label: 'No Data Found' , value: '', disabled: true}];
      }
    });
  }
  FinanceFormField(): void {
    this.financeForm = this.formBuilder.group({
      source_id: ['', Validators.required],
      entity_type_id: ['', Validators.required],
      bank_id: ['', Validators.required],
      account_type: ['', Validators.required],
      ifsc_code: ['', Validators.required],
      acc_no: ['', Validators.required],
      micr: [''],
      beneficiary: [''],
      is_salary: [''],
      is_reimburse: [''],
      is_tds_enable: [''],
      branch_add: [''],
      fin_id: [''],
      acc_file: ['']
    });
  }

  getEntityFinance(): void {
    this.genhttp.getEntityFinance({ entityId: this.entitytypeid, sourceId: this.sourceid, types: 'FINANCE'}).subscribe(data => {
      this.response = data;
      if (this.response.status === false) {

      } else if (this.response.status === true) {
        this.myFinance = this.response.data;
      }
    });
  }

  getReimbursementBank(): void {
    this.genhttp.getReimbursementBank({ entityId: this.entitytypeid, sourceId: this.sourceid}).subscribe(data => {
      this.response = data;
      if (this.response.status === false) {

      } else if (this.response.status === true) {
        this.getRemBank = this.response.data;
      }
    });
  }

  // tslint:disable-next-line: typedef
  get addErrorMsg() { return this.financeForm.controls; }

  addFinance(id , header): void {
    this.dynamicHeader = header;
    // this.FinanceFormField();
    this.financeForm.patchValue({
      source_id: this.sourceid,
      entity_type_id: this.entitytypeid,
      table: this.logTable
    });
    $(id).modal('show');
  }

  editFinance(id , header): void {
    this.dynamicHeader = header;
    this.httpOrg.editFinance(id).subscribe(data => {
      this.response = data;
      console.log(this.response);
      if (this.response.status === true) {
        // this.editFile = ;
        this.FileBank = this.response.data.attachment,
        this.financeForm.patchValue({
          bank_id: this.response.data.bnk_id,
          entity_type_id: this.response.data.entity_type_id,
          source_id: this.response.data.source_id,
          ifsc_code: this.response.data.ifsc,
          acc_no: this.response.data.acc_no,
          account_type: parseInt(this.response.data.acc_type),
          micr: this.response.data.micr,
          beneficiary: this.response.data.beneficiary,
          is_salary: this.response.data.is_salary,
          is_reimburse: this.response.data.is_reimburse,
          is_tds_enable: this.response.data.is_tds_enable,
          branch_add: this.response.data.brch_add,
          fin_id: this.response.data.fin_id
        });
        $('#zero_add_finance').modal('show');
      }
    });
  }

  deleteFinance(id): void {
    this.httpOrg.deleteFinance(id).subscribe(data => {
      this.response = data;
      if (this.response.status === true) {
        this.notifyService.showSuccess(this.response.msg, 'Success!');
        this.myFinance = this.myFinance.filter(val =>  val.fin_id !== id);
        this.empLogsAdd();
      } else if (this.response.status === false) {
        this.notifyService.showInfo(this.response.msg, 'Info!');
      }
    });
  }

  onSubmitFinance(): void {
    this.subAdd = true;
    if (this.financeForm.invalid) {
      return;
    } else {

      const offerFormData = new FormData();
      offerFormData.append('fin_id', this.financeForm.get('fin_id').value);
      offerFormData.append('acc_no', this.financeForm.get('acc_no').value);
      offerFormData.append('bank_id', this.financeForm.get('bank_id').value);
      offerFormData.append('account_type', this.financeForm.get('account_type').value);
      offerFormData.append('ifsc_code', this.financeForm.get('ifsc_code').value);
      offerFormData.append('entity_type_id', this.entitytypeid);
      offerFormData.append('source_id', this.sourceid);
      offerFormData.append('acc_file', this.bankFile);
      offerFormData.append('old_file', this.FileBank);
      offerFormData.append('table', this.logTable);

      this.httpOrg.addFinance(offerFormData, this.financeForm.get('fin_id').value).subscribe(data => {
        this.subAdd = false;
        this.loading = false;
        this.response = data;
        this.empLogsAdd();
        if (this.response.status === false) {
          this.notifyService.showInfo(this.response.info, 'Info!');
        } else if (this.response.status === true) {
          this.getEntityFinance();
          this.financeForm.reset();
          $('#zero_add_finance').modal('hide');
          this.notifyService.showSuccess(this.response.msg, 'Success!');
          this.empLogsAdd();
        }
      });
    }
  }

  onResetFinance(): void {
    this.FinanceFormField();
  }

  onFileChange(event): void {
    this.bankFile = [];
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.bankFile = file;
    }
  }

}
